module.exports = __webpack_public_path__ + "img/detailWx.9f2096ab.png";